import { render, staticRenderFns } from "./LottoResult.vue?vue&type=template&id=564f9dcc&scoped=true"
import script from "./LottoResult.vue?vue&type=script&lang=js"
export * from "./LottoResult.vue?vue&type=script&lang=js"
import style0 from "./LottoResult.vue?vue&type=style&index=0&id=564f9dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f9dcc",
  null
  
)

export default component.exports